/**
 * 安全的日期格式化工具
 * @param dateValue 支持：ISO字符串、Date对象、时间戳、undefined、null
 * @param format 格式化模板，默认 YYYY-MM-DD
 * @returns 格式化后的日期字符串，无效值返回空字符串
 */
export function formatDateSafe(
  dateValue?: string | number | Date | null,
  format = 'YYYY-MM-DD',
): string {
  // 1. 空值直接返回空字符串
  if (!dateValue) return ''

  // 2. 转换为 Date 对象
  const date = new Date(dateValue)

  // 3. 校验日期是否有效（无效日期返回 NaN）
  if (isNaN(date.getTime())) return ''

  // 4. 获取年月日（自动补零）
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  // 5. 替换模板并返回
  return format.replace('YYYY', String(year)).replace('MM', month).replace('DD', day)
}
